import { Inject } from '@angular/core';
import { APP_CONFIG } from '../app-config.constants';
import { IAppConfig } from '../app-config.interface';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ObjectResponse } from '../classes/object-response';
import { CacheService } from './cache.service';
import { catchError, tap } from 'rxjs/operators';
import { ApiConfigService } from './api-config/api-config.service';
import { IEnhancedContentResponse, EnhancedContentResponse } from '../classes/enhanced-content';
import { Subject, Observable, of } from 'rxjs';
import { ListingCategory } from '../classes/enums';

export class EnhancedContentService {
    private subject = new Subject<EnhancedContentResponse>();

    constructor(@Inject(APP_CONFIG) private appConfig: IAppConfig,
        private http: HttpClient,
        private apiConfig: ApiConfigService,
        private cache: CacheService
    ) {
    }

    public pushEnhancedContent(province?: string, city?: string, currentListingCategory?: ListingCategory): void {
      if (currentListingCategory !== ListingCategory.RESIDENTIAL) {
        this.subject.next(null);
        return;
      }

        if (!province && !city) {
            this.subject.next(null);
            return;
        }

        const base = this.apiConfig.getServerRoot(this.appConfig.urls.agent.base);
        const route = this.appConfig.urls.enhancedContent.base;
        const fullPath = base + route + province + '/' + city ? city.replace(/ /g, '-') : '';

        const hashKey = this.cache.getRequestHash(fullPath);
        const hashValue = this.cache.get<EnhancedContentResponse>(hashKey);

        // If the hashed value exists then just push it and return.
        if (hashValue !== undefined) {
            if (hashValue === null) {
                this.subject.next(null);
            } else {
                this.subject.next(hashValue);
            }
            return;
        }

        this.http.get<ObjectResponse<IEnhancedContentResponse>>(fullPath, { withCredentials: true })
            .pipe(
                catchError((err: HttpErrorResponse) => of(null)),
                tap(res => {
                    if (res && res.result) {
                        this.cache.set(hashKey, new EnhancedContentResponse(province, city, res.result.content), 300)
                    } else {
                        this.cache.set(hashKey, null, 300)
                    }
                })
            ).toPromise()
            .then(data => {
                if (data && data.result) {
                    this.subject.next(new EnhancedContentResponse(province, city, data.result.content));
                } else {
                    this.subject.next(null);
                }
            }).catch(err => {
              console.error(err)
              this.subject.next(null);
            });
    }

    public getSubject(): Observable<any> {
        return this.subject.asObservable();
    }

}
